import React from 'react';
import dateFormat from 'dateformat';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { useTranslation } from 'react-i18next';
import classes from './appliedJobCard.module.scss';
import { useQuery } from '../../../../utils/hooks';
import { setClassForStatusBubble } from '../../../../utils/helpers';

function AppliedJobCard(props) {
  const { job, jobId, cretedDate, status, menuHandler, dots } = props;
  const { t } = useTranslation();
  const query = useQuery();
  const isSavedTab = query.get('tab') === 'saved';

  return (
    <section className={job?.IsActive ? classes.jobCard : classes.closedStatusRow}>
      <div className={`${classes.titleContainer} d-flex gap-2 mb-1 flex-wrap`}>
        <span>{job?.JobTitle}</span>
        <span className={`${classes.textId} ${classes.secondaryText}`}>{jobId}</span>
      </div>
      <span className={`${classes.secondaryText} mb-3`}>{job?.Industry}</span>
      <div className="d-flex gap-2 mb-2 flex-wrap">
        <span className={`${classes.iconWithText} ${classes.secondaryText}`}>
          <LocationOnOutlinedIcon className={classes.iconWithTextIcon} />
          {job?.Location}
        </span>
        <span className={`${classes.iconWithText} ${classes.secondaryText}`}>
          <ArticleOutlinedIcon className={classes.iconWithTextIcon} />
          {job?.JobType}
        </span>
        {isSavedTab ? (
          <div>{!job?.IsActive ? <span className={classes.jobStatus}>{t('jobs.status.closed')}</span> : null}</div>
        ) : (
          <div className={setClassForStatusBubble(status, classes)}>{status}</div>
        )}
      </div>
      {!isSavedTab ? (
        <span className={classes.secondaryText}>{`${t('dashboard.jobs.appliedlist.submittedon')} ${dateFormat(
          cretedDate,
          'dd mmm yyyy'
        )}`}</span>
      ) : null}
      {dots && (
        <div role="presentation" data-testid="menu" className={classes.threeDotMenu} onClick={menuHandler}>
          <MoreVertIcon />
        </div>
      )}
    </section>
  );
}

export default AppliedJobCard;
